module.exports = __webpack_public_path__ + "static/img/banner-4.5e5a219.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner-4.jpg
// module id = T3V7
// module chunks = 36